import { useAnalytics } from '@backstage/core-plugin-api';

export const sendTechDocsViewEvent = (
  analytics: ReturnType<typeof useAnalytics>,
  entityRef: string,
  kind: string,
  name: string,
  namespace: string,
) => {
  analytics.captureEvent('techdocs_view', `${kind}_${name}`, {
    value: 1,
    attributes: {
      entityRef,
      entityKind: kind,
      entityName: name,
      namespace,
    },
  });
};
